const stables = document.querySelectorAll(".Stable");

if (stables.length > 0) {
    const resize = () => {
        stables.forEach((st) => {
            const ttls = st.querySelectorAll(".Stable__scrollCntLineTtl");
            const lines = st.querySelectorAll(".Stable__scrollCntLine");

            ttls.forEach((ttl, index) => {
                const target = lines[index].querySelector(
                    ".Stable__scrollCntLineRows"
                );

                ttl.style.height = ``;
                target.style.height = ``;

                if (innerWidth <= 1024 && !st.classList.contains("commonsp")) {
                    setTimeout(() => {
                        const ttlHeight = ttl.getBoundingClientRect().height;
                        const targetHeight =
                            target.getBoundingClientRect().height;
                        if (ttlHeight > targetHeight) {
                            target.style.height = `${ttlHeight}px`;
                        } else {
                            ttl.style.height = `${targetHeight}px`;
                        }
                    }, 200);
                }
            });
        });
    };

    resize();

    let resizeTimeout;
    let prevWidth = innerWidth;

    window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            if (prevWidth !== innerWidth) {
                prevWidth == innerWidth;
                resize();
            }
        }, 200);
    });
}
